<div class="dialog-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="grid-column d-grid gap-14">
        <div class="form-group">
            <app-input context="Normal" class="form-item" label="Partner name" placeholder="Enter your partner name"
                type="text" [control]="form.get('partnerName')" formControlName="partnerName" [required]=true
                [customErrorMessages]="customErrorMessages.partnerName">
            </app-input>
        </div>

        <div class="form-group">
            <app-input context="Normal" class="form-item" label="Contact name" placeholder="Enter your contact name"
                [optional]=true type="text" [control]="form.get('contactName')" formControlName="contactName"
                [customErrorMessages]="customErrorMessages.contactName">
            </app-input>
        </div>

        <div class="form-group">
            <app-input context="Normal" class="form-item" label="Contact email" placeholder="Enter your contact email"
                [optional]=true type="text" [control]="form.get('contactEmail')" formControlName="contactEmail"
                [customErrorMessages]="customErrorMessages.contactEmail">
            </app-input>
        </div>

        <div class="form-group">
            <app-input context="Normal" class="form-item" label="Contact phone" placeholder="Enter your contact phone"
                [optional]=true type="text" [control]="form.get('contactPhone')" formControlName="contactPhone"
                [customErrorMessages]="customErrorMessages.contactPhone">
            </app-input>
        </div>

        <button type="submit" style="display: none;" #submitBtn></button>
    </form>
</div>